import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

interface InvitationHeaderProps {
  organizationName: string;
  inviterName: string;
  subtitle?: string;
}

export function InvitationHeader({ organizationName, inviterName, subtitle }: InvitationHeaderProps) {
  return (
    <Card className="mb-6 border-0 bg-transparent shadow-none">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">Rejoignez {organizationName}</CardTitle>
        <CardDescription>
          Invitation de {inviterName}
          {subtitle && <span className="mt-1 block">{subtitle}</span>}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
